import $ from 'jquery';
import { generateIconElement, ICON } from "../../Icons/Icons";
import { FEATURE_NAMES } from "../../MVC/rolesHelper";
import AlertNotification from "../Notifications/AlertNotification";

/**
 * SpaceDowngradeModal - A component for downgrading space
 */
class SpaceDowngradeModal {
  template() {
    return `
<div class="confirm-modal confirm-modal--light-theme middle space-select-modal">
  <div class="confirm-dialog">
    ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
    
    <div class="space-select-modal__title" data-lang="make-space-public-question">
      ${$trans('make-space-public-question')}
    </div>
    
    <div class="confirm-footer my-5">
      <button class="buttn secondary downgrade-space-modal__cancel" data-lang="cancel-text">
        ${$trans('cancel-text')}
      </button>
      
      <button class="buttn primary downgrade-space-modal__confirm" data-lang="ok-text">
        ${$trans('ok-text')}
      </button>
    </div>
    
    <div class="space-select-modal__differences-question" data-lang="space-select-differences-question" data-show-actions="false">
      ${$trans('space-select-differences-question')}
    <div
  </div>
</div>
    `
  }

  ///constructor
  constructor({ onConfirm = () => {} } = {}) {
    this.onConfirm = onConfirm

    this.render()
    this.addEventListeners()
  }
  ///render
  render() {
    this.$modal = $(this.template());
    $('body').append(this.$modal);
  }

  addEventListeners() {
    this.$modal.find('.confirm-close').on('click', () => {
      this.hide()
    })

    this.$modal.find('.downgrade-space-modal__cancel').on('click', () => {
      this.hide()
    })

    this.$modal.find('.downgrade-space-modal__confirm').on('click', () => {
      this.hide()
      typeof this.onConfirm === 'function' && this.onConfirm()
    })
  }

  show(onConfirm = () => {}) {
    this.onConfirm = onConfirm

    this.$modal.addClass('visible').show();
  }

  hide() {
    this.$modal.removeClass('visible').hide();
  }
}

export default SpaceDowngradeModal;
